import i18n from 'services/base/i18n';

export default {
  AM:     () => i18n.pgettext('Components|Clock', 'AM'),
  PM:     () => i18n.pgettext('Components|Clock', 'PM'),
  cancel: () => i18n.pgettext('Components|Clock', 'CANCEL'),
  ok:     () => i18n.pgettext('Components|Clock', 'OK'),
};
